import React, { useEffect, useState } from "react";
import { Share2, Copy, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const LABELS = { instagram: "Instagram", facebook: "Facebook", story: "Story sticker" };

export const CaptionDialog = ({ item, kind, onClose }) => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const generate = async () => {
    setBusy(true);
    try {
      const r = await api.post("/admin/ai/caption", { item, kind });
      setData(r.data);
    } catch (err) {
      toast.error(err.response?.data?.detail || "AI couldn't write that just now.");
    } finally { setBusy(false); }
  };

  useEffect(() => { if (item) { setData(null); generate(); } }, [item]); // eslint-disable-line react-hooks/exhaustive-deps

  const copy = (text) => { navigator.clipboard?.writeText(text); toast.success("Copied to clipboard."); };

  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="caption-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl inline-flex items-center gap-2"><Share2 size={20} /> Social captions — {item?.title || item?.name}</DialogTitle></DialogHeader>
        {busy && !data ? <div className="py-10 text-center text-sm text-[color:var(--ink-2)] animate-pulse" data-testid="caption-loading">Writing captions…</div> : data && (
          <div className="space-y-4">
            {Object.entries(LABELS).map(([k, l]) => data[k] && (
              <div key={k} className="rounded-2xl border border-[color:var(--line)] bg-white p-4" data-testid={`caption-${k}`}>
                <div className="flex items-center justify-between mb-2">
                  <div className="text-[0.68rem] uppercase tracking-[0.14em] font-bold text-[color:var(--coral)]">{l}</div>
                  <button onClick={() => copy(data[k])} data-testid={`caption-copy-${k}`} className="btn-pill btn-ghost text-xs py-1 px-2"><Copy size={12} /> Copy</button>
                </div>
                <p className="text-sm whitespace-pre-line leading-relaxed">{data[k]}</p>
              </div>
            ))}
            <button onClick={generate} disabled={busy} data-testid="caption-regenerate" className="btn-pill btn-outline text-xs disabled:opacity-50"><RefreshCw size={12} className={busy ? "animate-spin" : ""} /> {busy ? "Rewriting…" : "Try another version"}</button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
